import { useTranslation } from "react-i18next";

import type { FilterMenuOption } from "@/components/common/FilterMenuButton";
import { type SortDirection, SortSelectorControl } from "@/components/common/SortSelectorControl";

interface RecordSortControlProps<T extends string> {
  value: T | null;
  options: FilterMenuOption<T>[];
  direction: SortDirection;
  onSort: (column: T) => void;
}

export function RecordSortControl<T extends string>({
  value,
  options,
  direction,
  onSort,
}: RecordSortControlProps<T>) {
  const { t } = useTranslation();
  return (
    <SortSelectorControl
      value={value ?? ""}
      options={options}
      direction={direction}
      onChange={(column) => {
        if (column) onSort(column);
      }}
      onDirectionChange={() => {
        if (value !== null) onSort(value);
      }}
      directionDisabled={value === null}
      label={t("common.records.sortBy")}
      menuTitle={t("common.records.sortBy")}
      directionAriaLabel={t("common.records.toggleSortDirection")}
    />
  );
}
